// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"223":"f4e68514233700ec0d0a","843":"2f450fd1bb8099263ecc"}[chunkId] + ".js";
};